import type { RootState } from 'store/wos_store';
import type { LGRootState } from 'store/link_generator_store';
import type { CheckoutRootState } from 'store/checkout_store';

export const selectCartLoading = (state: RootState) => {
  return state.cart.status === 'loading';
};

export const selectCartPageLoading = (state: RootState) =>
  state.cart.status === 'loading' && !state.cart.betterCart && !state.cart.cartCheck;

export const selectCartLoaded = (state: RootState) => {
  return state.cart.status === 'idle' && (!!state.cart.betterCart || state.cart.cartCheck);
};

export const selectCartProductsLoading = (state: RootState | CheckoutRootState) => {
  return state.cartProducts.status === 'loading';
};

export const selectCatalogsLoading = (state: RootState) => {
  return state.catalogs.status === 'loading';
};

export const selectCatalogsLoaded = (state: RootState | LGRootState) => {
  return state.catalogs.status === 'idle' && state.catalogs.ids.length > 0;
};

export const selectCatalogsLoadError = (state: RootState) => {
  return state.catalogs.status === 'error';
};

export const selectSubcatalogsLoading = (state: RootState) => {
  return state.subcatalogs.status === 'loading';
};

export const selectSubcatalogsLoaded = (state: RootState) => {
  return state.subcatalogs.status === 'idle' && state.subcatalogs.ids.length > 0;
};

export const selectSubcatalogsLoadError = (state: RootState) => {
  return state.subcatalogs.status === 'error';
};

export const selectOptionsLoading = (state: RootState) => {
  return state.optionGroups.status === 'loading';
};

export const selectOptionsLoaded = (state: RootState) => {
  return state.optionGroups.status === 'idle' && state.optionGroups.ids.length > 0;
};

export const selectOptionsLoadError = (state: RootState) => {
  return state.optionGroups.status === 'error';
};

export const selectCustomPriceLoading = (state: RootState) => {
  return state.canvases.status === 'loading';
};

export const selectCustomPriceLoaded = (state: RootState) => {
  return (
    state.canvases.status === 'idle' &&
    state.canvases.active &&
    !!state.canvases.entities[state.canvases.active]?.customPrice
  );
};

export const selectCustomPriceError = (state: RootState) => {
  return state.canvases.status === 'error';
};

export const selectCanvasProductLoading = (state: RootState) => {
  return state.subcatalogs.status === 'loading' || state.optionGroups.status === 'loading';
};

export const selectProjectsLoading = (state: RootState) => {
  return state.projects.status === 'loading';
};
